import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class CollectionMetadataResponse {
  @jsonMember readonly page!: number;
  @jsonMember readonly total!: number;
  @jsonMember readonly limit!: number;
}
